import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { COLLECTION_TILES } from "../lib/home-content";

import MarqueeMasthead from "../components/sections/MarqueeMasthead";
import HeroSection from "../components/sections/HeroSection";
import AboutSection from "../components/sections/AboutSection";
import BadgesSection from "../components/sections/BadgesSection";
import StatsBand from "../components/sections/StatsBand";
import GallerySection from "../components/sections/GallerySection";
import VisitSection from "../components/sections/VisitSection";
import FinalCTASection from "../components/sections/FinalCTASection";

const Home = () => {
  // Hybrid gallery: default to curated tiles; swap to admin-featured products
  // when site settings gallery_mode === "featured" AND the API returns items.
  const [displayTiles, setDisplayTiles] = useState(COLLECTION_TILES);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data: settings } = await api.get("/site/settings");
        if (settings?.gallery_mode !== "featured") return;
        const { data: items } = await api.get("/home-gallery");
        if (cancelled) return;
        if (Array.isArray(items) && items.length > 0) {
          setDisplayTiles(
            items.slice(0, 6).map((p) => ({
              name: p.name,
              category: p.category,
              image_url: p.image_url,
            }))
          );
        }
      } catch {
        // Network/API failure → silently keep curated fallback
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div data-testid="home-page">
      <MarqueeMasthead />
      <HeroSection />
      <AboutSection />
      <BadgesSection />
      <StatsBand />
      <GallerySection tiles={displayTiles} />
      <VisitSection />
      <FinalCTASection />
    </div>
  );
};

export default Home;
